var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_520_381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 17.8845C1.0375 17.8845 0.859417 17.8127 0.71575 17.669C0.571917 17.5252 0.5 17.3469 0.5 17.1343C0.5 16.9218 0.571917 16.7437 0.71575 16.6C0.859417 16.4565 1.0375 16.3848 1.25 16.3848H2.30775V8.923C2.30775 7.57817 2.72283 6.38908 3.553 5.35575C4.383 4.32242 5.44867 3.6615 6.75 3.373V2.75C6.75 2.40283 6.87142 2.10767 7.11425 1.8645C7.35708 1.6215 7.65192 1.5 7.99875 1.5C8.34575 1.5 8.641 1.6215 8.8845 1.8645C9.12817 2.10767 9.25 2.40283 9.25 2.75V3.373C10.5513 3.6615 11.617 4.32242 12.447 5.35575C13.2772 6.38908 13.6923 7.57817 13.6923 8.923V16.3848H14.75C14.9625 16.3848 15.1406 16.4566 15.2843 16.6003C15.4281 16.7441 15.5 16.9223 15.5 17.135C15.5 17.3475 15.4281 17.5256 15.2843 17.6693C15.1406 17.8128 14.9625 17.8845 14.75 17.8845H1.25ZM7.99825 20.6923C7.50075 20.6923 7.07542 20.5153 6.72225 20.1613C6.36892 19.8073 6.19225 19.3817 6.19225 18.8845H9.80775C9.80775 19.3833 9.63058 19.8093 9.27625 20.1625C8.92192 20.5157 8.49592 20.6923 7.99825 20.6923ZM3.80775 16.3848H12.1923V8.923C12.1923 7.76533 11.783 6.77725 10.9645 5.95875C10.1458 5.14008 9.15767 4.73075 8 4.73075C6.84233 4.73075 5.85417 5.14008 5.0355 5.95875C4.217 6.77725 3.80775 7.76533 3.80775 8.923V16.3848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 4,
    r: 4,
    fill: "#d9534f"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_520_381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.f610653792aacce30af8e47e1d25a1b1.svg";
export { ForwardRef as ReactComponent };